/**
 * templateVar.ts
 * Generate a clean, user-friendly template variable name from an Excel column
 * header, so end users never have to rename columns to get a usable `{{var}}`.
 *
 * Examples:
 *   "Số kiện"        -> "so_kien"
 *   "Mã điểm giao"   -> "ma_diem_giao"
 *   "SL thực nhận"   -> "sl_thuc_nhan"
 *   "Tên KH"         -> "ten_kh"
 *   "Unit Price"     -> "unit_price"
 */

/**
 * Strip Vietnamese diacritics and lowercase, then collapse spaces to
 * underscores. Keeps letters, digits, underscore. Drops everything else.
 */
export function toTemplateVar(header: string): string {
  if (!header) return "";
  const cleaned = header
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // strip diacritics (á -> a)
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .replace(/_+/g, "_");
  return cleaned;
}

/** `{{so_kien}}` form, or empty when the header produces no variable. */
export function templateVarExpr(header: string): string {
  const v = toTemplateVar(header);
  return v ? `{{${v}}}` : "";
}
